module.exports = __webpack_public_path__ + "static/media/initialMobilePoster.f0cf17ee.webp";